import { NavLink, useLocation } from 'react-router-dom'
import Drawer from '@mui/material/Drawer'
import Toolbar from '@mui/material/Toolbar'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { ThemeProvider, Typography, createTheme } from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import BookIcon from '@mui/icons-material/Book'
import HomeIcon from '@mui/icons-material/Home'
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary'
import PhotoAlbumIcon from '@mui/icons-material/PhotoAlbum'
import CampaignIcon from '@mui/icons-material/Campaign'
import logo from '../assets/logo-light.svg'

export const SideNav = ({
    mobileOpen,
    handleDrawerClose,
    handleDrawerTransitionEnd,
    userData,
}) => {
    const navItems = [
        {
            displayName: 'Calendar',
            routeTo: '/merchant/calendar_v2',
            icon: <CalendarMonthIcon />,
        },
        {
            displayName: 'Create AI Quotes Campaign',
            routeTo: '/merchant/create_ai_quotes_campaign_v2',
            icon: <SmartToyIcon />,
        },
        {
            displayName: 'Create Blog Campaign',
            routeTo: '/merchant/create_blog_campaign_v2',
            icon: <BookIcon />,
        },
        {
            displayName: 'Create Listing Campaign',
            routeTo: '/merchant/create_listing_campaign',
            icon: <HomeIcon />,
        },
        {
            displayName: 'Create Video Campaign',
            routeTo: '/merchant/create_video_campaign',
            icon: <VideoLibraryIcon />,
        },
        {
            displayName: 'My Template Library',
            routeTo: '/merchant/template_library',
            icon: <PhotoAlbumIcon />,
        },
        {
            displayName: 'View Campaigns',
            routeTo: '/merchant/view_campaigns',
            icon: <CampaignIcon />,
        },
    ]

    const drawerWidth = 280
    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#313a46',
            },
        },
    })

    const isNestedView = (navItem) => {
        const pathname = useLocation().pathname
        if (navItem === 'View Campaigns')
            return (
                pathname.includes('view_campaign') ||
                pathname.includes('merchant/campaigns')
            )
        if (navItem === 'My Template Library')
            return pathname.includes('merchant/builder')
        return false
    }

    const navBuild = (
        <>
            <Toolbar>
                <img
                    src={logo}
                    alt="logo"
                    style={{ margin: '0 auto', width: '5rem' }}
                />
            </Toolbar>
            <List>
                <ListItem disablePadding>
                    <Typography
                        textTransform="uppercase"
                        fontSize="0.75rem"
                        fontWeight="bold"
                        color="#8391A2"
                        sx={{
                            padding: '1rem 1rem',
                        }}
                    >
                        {userData?.name}
                    </Typography>
                </ListItem>
                {navItems.map((item) => (
                    <NavLink
                        key={item.displayName}
                        to={item.routeTo}
                        style={{ textDecoration: 'none' }}
                        className="navlink"
                    >
                        {({ isActive }) => (
                            <ListItem key={item.displayName} disablePadding>
                                <ListItemButton
                                    sx={{
                                        color:
                                            isActive ||
                                            isNestedView(item.displayName)
                                                ? 'white'
                                                : '#8391A2',
                                        '.MuiSvgIcon-root': {
                                            fontSize: '1rem',
                                            color:
                                                isActive ||
                                                isNestedView(item.displayName)
                                                    ? 'white'
                                                    : '#8391A2',
                                        },
                                        '&:hover': {
                                            color: '#bccee4',
                                            backgroundColor: '#ff000000',
                                        },
                                        '&:hover .MuiSvgIcon-root': {
                                            color: '#bccee4',
                                        },
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            minWidth: '0',
                                            pr: '1rem',
                                        }}
                                    >
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.displayName}
                                        sx={{
                                            textDecoration: 'none',
                                            fontSize: '0.75rem',
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        )}
                    </NavLink>
                ))}
            </List>
        </>
    )

    return (
        <ThemeProvider theme={darkTheme}>
            {/* MOBILE DRAWER */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onTransitionEnd={handleDrawerTransitionEnd}
                onClose={handleDrawerClose}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: drawerWidth,
                        backgroundColor: '#313a46',
                    },
                }}
                slotProps={{
                    root: {
                        keepMounted: true, // Better open performance on mobile.
                    },
                }}
            >
                {navBuild}
            </Drawer>
            {/* MOBILE DRAWER ENDS */}

            {/* DESKTOP SIDENAV */}
            <Drawer
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: '#313a46',
                    },
                }}
                variant="permanent"
                anchor="left"
            >
                {navBuild}
            </Drawer>
            {/* DESKTOP SIDENAV ENDS */}
        </ThemeProvider>
    )
}
